import React, { useRef, useState, useCallback, useEffect } from 'react'

//* Gsap functions
import { slideDown } from 'helpers/_gsapFunctions'

//* Components
import Text from 'components/common/Text'
import Image from 'components/common/Image'
import AnimationWrap from 'components/common/AnimationWrap'

//* Style
import AppSectionStyle from './style'

//* HOC's
import { withUIContext } from 'context'

const AppSection = ({ appData, appVideo, winWidth }) => {
    //! States
    const [secObj, setSecObj] = useState()

    //! Refs
    const items = useRef([])
    const titleRef = useRef([])
    const subtitleRef = useRef([])
    const descriptionRef = useRef([])
    const appStoreRef = useRef([])
    const googleMarketRef = useRef([])

    useEffect(() => {
        if (items?.current) {
            setSecObj([items.current])
        }
    }, [items, winWidth])

    const startAnimeArr = useCallback((x) => {
        if (x) {
            //! slideDown(item, stagger, delay)
            slideDown([titleRef.current, subtitleRef.current, descriptionRef.current, appStoreRef.current, googleMarketRef.current], 0.2)
        }
    }, [])

    return (
        <AppSectionStyle>
            <AnimationWrap state={secObj} startAnimeArr={startAnimeArr}>
                <div ref={items}>
                    <div className='overflowHidden'>
                        <Text ref={titleRef} tag='h3' className='animStartPos terminaBold orange' text='ngSlotApp' />
                    </div>
                    <div className='overflowHidden'>
                        <Text ref={subtitleRef} className='h5 animStartPos terminaBold maisonSemiBold appSubtitle' text={appData.app_subtitle} />
                    </div>
                    <div className='FlexBox descriptionWrap'>
                        <div className='overflowHidden'>
                            <Text className='h9 terminaBold maisonMedium appDescription animStartPos' ref={descriptionRef} text={appData.app_text} />
                        </div>
                        <div className='downloadLinkWrap FlexBox spaceBetween'>
                            <a href={appData.app_store_link} target='_blank' className='appStoreLink overflowHidden'>
                                <Image src='/images/appStore.png' className='animStartPos' ref={appStoreRef} />
                            </a>
                            <a href={appData.google_play_link} target='_blank' className='overflowHidden googlePlayLink'>
                                <Image src='/images/googlePlay.png' className='animStartPos' ref={googleMarketRef} />
                            </a>
                        </div>
                    </div>
                </div>
                <div className="appVideo">
                    <div className="video-cont">
                        <video autoPlay loop muted playsInline>
                            <source src={appVideo} type='video/mp4' />
                        </video>
                    </div>
                </div>
            </AnimationWrap>
        </AppSectionStyle>
    )
}

export default withUIContext(AppSection, ['winWidth'])
